import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import { useToast } from '../components/useToast'
import { useLanguage } from '../hooks/useLanguage'

export default function EliminarCuenta() {
  const navigate = useNavigate()
  const toast = useToast()
  const { t } = useLanguage()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [confirmText, setConfirmText] = useState('')
  const [deleting, setDeleting] = useState(false)
  const [step, setStep] = useState(1)

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setUser(data.user || null)
      setLoading(false)
    })
  }, [])

  const palabraConfirmacion = t('eliminar_cuenta_palabra_confirmacion')

  async function handleDelete() {
    if (confirmText.trim().toUpperCase() !== palabraConfirmacion.toUpperCase()) {
      toast.warning(t('eliminar_cuenta_confirm_warning'))
      return
    }
    setDeleting(true)
    try {
      const { data: sessionData } = await supabase.auth.getSession()
      const token = sessionData?.session?.access_token
      const { error } = await supabase.functions.invoke('eliminar-cuenta', {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (error) throw error
      await supabase.auth.signOut()
      toast.success(t('eliminar_cuenta_exito'))
      navigate('/login')
    } catch (err) {
      console.error(err)
      toast.error(t('eliminar_cuenta_error'), t('eliminar_cuenta_error_desc'))
    } finally {
      setDeleting(false)
    }
  }

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f0f10', color: '#fff' }}>...</div>
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f10', color: '#fff', padding: '40px 20px', display: 'flex', justifyContent: 'center' }}>
      <div style={{ maxWidth: 560, width: '100%' }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 8 }}>{t('eliminar_cuenta_titulo')}</h1>
        <p style={{ color: '#9ca3af', lineHeight: 1.6, marginBottom: 24 }}>{t('eliminar_cuenta_intro')}</p>

        <div style={{ background: '#17181c', border: '1px solid #27272a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>{t('eliminar_cuenta_que_titulo')}</h2>
          <ul style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.7, paddingLeft: 18 }}>
            <li>{t('eliminar_cuenta_item1')}</li>
            <li>{t('eliminar_cuenta_item2')}</li>
            <li>{t('eliminar_cuenta_item3')}</li>
            <li>{t('eliminar_cuenta_item4')}</li>
          </ul>
          <p style={{ color: '#f59e0b', fontSize: 12, marginTop: 12 }}>{t('eliminar_cuenta_aviso')}</p>
        </div>

        {!user ? (
          <div style={{ background: '#17181c', border: '1px solid #27272a', borderRadius: 16, padding: 20 }}>
            <p style={{ color: '#9ca3af', fontSize: 14, marginBottom: 16 }}>{t('eliminar_cuenta_login_req')}</p>
            <button
              onClick={() => navigate('/login?redirect=/eliminar-cuenta')}
              style={{ padding: '12px 20px', borderRadius: 12, border: 'none', background: '#3b82f6', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
            >
              {t('eliminar_cuenta_login_btn')}
            </button>
          </div>
        ) : step === 1 ? (
          <button
            onClick={() => setStep(2)}
            style={{ width: '100%', padding: 16, borderRadius: 14, border: 'none', background: '#ef4444', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}
          >
            {t('eliminar_cuenta_continuar')}
          </button>
        ) : (
          <div style={{ background: '#17181c', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 16, padding: 20 }}>
            <p style={{ fontSize: 13, color: '#9ca3af', marginBottom: 12 }}>
              {t('eliminar_cuenta_confirmar_texto')} <strong style={{ color: '#fff' }}>{palabraConfirmacion}</strong> — {user.email}
            </p>
            <input
              value={confirmText}
              onChange={e => setConfirmText(e.target.value)}
              style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #333', background: '#0f0f10', color: '#fff', marginBottom: 14, boxSizing: 'border-box' }}
              placeholder={palabraConfirmacion}
            />
            <button
              onClick={handleDelete}
              disabled={deleting}
              style={{ width: '100%', padding: 14, borderRadius: 12, border: 'none', background: '#ef4444', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
            >
              {deleting ? t('eliminar_cuenta_eliminando') : t('eliminar_cuenta_confirmar_btn')}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}